// extracted by mini-css-extract-plugin
export default {"main":"burger-ingredients_main__rvXtd","scrollWrap":"burger-ingredients_scrollWrap__V1tLh"};